import { LoginComponent } from './login.component';

export default LoginComponent;
